import { ReactNode } from 'react';
import Head from 'next/head';
import clsx from 'clsx';

interface IPageLayoutProps {
  children: ReactNode;
  className?: string;
  stepIndex: number;
  title?: string;
}

/**
 * -----------------------------------------------------------------------------
 * The root page layout component. Currently, it only sets the page title.
 *
 * TODO: Handle cases for when title is an object with translations.
 *  - See other parts of the cosmetic app for examples.
 *  - Handle cases for when the user jumps between the screens.
 */
export function PageLayout({
  children,
  className = 'app-bg-grad',
  stepIndex,
  title,
}: IPageLayoutProps) {
  return (
    <>
      {title ? (
        <Head>
          <title>{title}</title>
        </Head>
      ) : null}

      <div
        className={clsx('page-container', className)}
        id={stepIndex?.toString()}
      >
        {children}
      </div>
    </>
  );
}
